module.exports = __webpack_public_path__ + "img/liturghier-1728-pagina-de-titlu-big.e0f9041b.jpg";